// The share visit a browser tab holds after its visitor entered a sharing link's emailed code.
//
// It is kept in session storage, keyed by the link's token, so a refresh in the same tab finds it
// again and a new tab (which starts with empty session storage) does not. Storage can be missing or
// refuse every access (private browsing, blocked site data); then nothing is kept and the visitor is
// simply asked for a code again. Nothing here ever throws.

const KEY_PREFIX = 'shareVisit:';

const storage = () => {
  try {
    return typeof window !== 'undefined' && window.sessionStorage ? window.sessionStorage : null;
  } catch (e) {
    return null;
  }
};

const keyFor = token => `${KEY_PREFIX}${token}`;

export const keepShareVisit = (token, { session, requestType } = {}) => {
  if (!token || typeof session !== 'string' || !session) return;
  try {
    storage()?.setItem(keyFor(token), JSON.stringify({ session, requestType: requestType || 'profile' }));
  } catch (e) {
    // Not kept: a refresh asks for a code again.
  }
};

// { shareVisit: { token, session }, requestType } for this link, or null.
export const readShareVisit = token => {
  if (!token) return null;
  try {
    const raw = storage()?.getItem(keyFor(token));
    if (!raw) return null;
    const stored = JSON.parse(raw);
    if (typeof stored?.session !== 'string' || !stored.session) return null;
    return {
      shareVisit: { token, session: stored.session },
      requestType: typeof stored.requestType === 'string' ? stored.requestType : 'profile',
    };
  } catch (e) {
    return null;
  }
};

export const forgetShareVisit = token => {
  if (!token) return;
  try {
    storage()?.removeItem(keyFor(token));
  } catch (e) {
    // Nothing to forget.
  }
};
